module.exports = __webpack_public_path__ + "h5/img/child-navc1.674fceb3.png";